// supabaseClient.js

import { createClient } from "@supabase/supabase-js";

// Function to return the Supabase client
export const getSupabaseClient = () => {
  const supabaseUrl = "https://fsjwbktrzltakpbrwdzz.supabase.co"; // Supabase URL
  const supabaseKey =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZzandia3Ryemx0YWtwYnJ3ZHp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk5Mzc2MTIsImV4cCI6MjA1NTUxMzYxMn0.YstcR-cqWqs7qdL6Q44s-HcZenujDcyIcfjceFN-vu0"; // Replace with Supabase API key
  // // Supabase API Key
  const supabase = createClient(supabaseUrl, supabaseKey);

  return supabase;
};
